import { FC, memo } from 'react';
import { ProductFilterForm, IProductFilterForm } from './ProductFilterForm';

export const ProductFilter: FC<IProductFilterForm> = memo((props) => (
  <ProductFilterForm {...props} />
));
